<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="font-jost-medium text-blue-dark text-base">{{ nft.chainName }} NFT</h2>
    <div class="flex items-center justify-between">    
      <!-- Middle: NFT Details -->
      <div class="flex-1 flex items-center gap-[50px] mr-4 min-w-0">
        <!-- NFT ID -->
        <div class="flex items-center min-w-0 flex-2">
          <span class="text-[#6B7280] font-medium mr-1 text-base">NFT Hash:</span>
          <span class="text-[#374151] font-jost-regular text-base break-all" :title="nft.hash">
            <router-link :to="{ name: 'nft', params: { chainNumber: nft.chainName || 'chainName', nftId: nft.hash } }">{{ nft.hash }}</router-link>
          </span>
        </div>

        <!-- Chain name -->
        <div class="flex items-center gap-2 text-base flex-2">
          <span class="text-[#6B7280]">Chain Name:</span>
            <RouterLink
              v-if="nft.chainNumber !== undefined && nft.chainNumber !== null"
              :to="{ name: 'chain', params: { chainNumber: nft.chainNumber } }"
              class="text-[#374151] font-jost-regular"
              :title="nft.chainName || 'N/A'"
            >
              {{ nft.chainName || 'N/A' }}
            </RouterLink>
            <span v-else class="text-[#374151] font-jost-regular" :title="nft.chainName || 'N/A'">
              {{ nft.chainName || 'N/A' }}
            </span>
        </div>

        <!-- Issuer if available -->
        <div class="flex items-center gap-2 text-base flex-2">
          <span class="text-[#6B7280]">Issuer:</span>
           <router-link v-if="nft.issuer" :to="{name: 'account', params: { chainNumber: nft.chainNumber, address: nft.issuer }}"
            class="text-[#374151] font-jost-regular text-base">
               <span class="text-[#374151] font-jost-regular" :title="nft.issuer || 'N/A'">
                {{ truncateAddress(nft.issuer) || 'N/A' }}
              </span>
          </router-link>
        </div>

        <!-- Owner if available -->
        <div class="flex items-center min-w-0 flex-1" v-if="nft.owner">
          <span class="text-[#6B7280] font-medium mr-1 text-base">Owner:</span>
           <router-link v-if="nft.owner" :to="{name: 'account', params: { chainNumber: nft.chainNumber, address: nft.owner }}"
            class="text-[#374151] font-jost-regular text-base">
               <span class="text-[#374151] font-jost-regular" :title="nft.owner || 'N/A'">
                {{ truncateAddress(nft.owner) || 'N/A' }}
              </span>
          </router-link>
        </div>
      </div>
      
      <!-- Right Side: Additional Info -->
      <div class="flex items-center gap-4 text-base">
        <div class="text-right min-w-[120px]">
          <div class="text-[#374151]">
            {{ nft.createdAt ? formatDateTime(nft.createdAt) : 'N/A' }}
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { truncateAddress, formatDateTime } from '@/helpers/common';

export default {
  name: 'NFTCard',
  props: {
    nft: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
    truncateAddress(address) {
      return truncateAddress(address);
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
